<script setup>
import { GA } from '@/mixins/Ga';

defineProps({
    title: {
        type: String,
        default: '',
    },
    brand: {
        type: String,
        default: '',
    },
    code: {
        type: String,
        default: '',
    },
    description: {
        type: String,
        default: '',
    },
    notes: {
        type: String,
        default: '',
    },
    url: {
        type: String,
        default: '',
    },
});
const ga = new GA({ category: 'promoCode', action: 'clicExterne' });
</script>

<template>
    <a
        class="DiscountsPromoCode relative flex w-full text-white"
        :href="url"
        :class="{
            'can-hover:hover:-translate-y-1 can-hover:hover:drop-shadow-lg mb-6 transition': url,
        }"
        v-on:click="ga.send({ label: title + ' ' + code, camelCase: false })"
    >
        <div class="flex flex-col">
            <div class="bg-dark-blue h-full rounded-tl-xl" />
            <div class="grow-0">
                <svg
                    class="text-dark-blue h-full w-auto fill-current"
                    width="16"
                    height="34"
                    viewBox="0 0 16 34"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        stroke="none"
                        d="M0 33.9711C8.92338 33.4535 16 26.0531 16 17V34H0V33.9711Z"
                    />
                    <path
                        stroke="none"
                        d="M0 0.0289236V0H16V17C16 7.94685 8.92338 0.546541 0 0.0289236Z"
                    />
                </svg>
            </div>
            <div class="bg-dark-blue h-full rounded-bl-xl" />
        </div>

        <div
            class="bg-dark-blue grid w-full grid-cols-2 p-4"
            :class="{
                'pb-4': url,
            }"
        >
            <div
                v-if="brand"
                class="DiscountsPromoCode__title col-span-2 mb-2 text-base font-bold leading-none md:text-lg md:leading-none"
            >
                <h3 class="text-light-yellow text-center text-2xl">{{ brand }}</h3>
            </div>
            <div class="DiscountsPromoCode__title text-base font-bold leading-none md:text-lg md:leading-none">
                <h3>{{ title }}</h3>
                <div class="DiscountsPromoCode__product text-xxs text-light-blue font-normal">{{ description }}</div>
            </div>
            <div class="DiscountsPromoCode__code text-light-yellow text-right text-base font-bold leading-none md:text-lg md:leading-none">
                <div>{{ code }}</div>
                <div class="text-sm font-normal text-white">avec le code promo</div>
                <div class="DiscountsPromoCode__notes text-xxs text-light-blue font-normal">{{ notes }}</div>
            </div>
        </div>
        <div class="flex flex-col">
            <div class="bg-dark-blue h-full rounded-tr-xl" />
            <div class="grow-0">
                <svg
                    class="text-dark-blue h-full w-auto rotate-180 fill-current"
                    width="16"
                    height="34"
                    viewBox="0 0 16 34"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        stroke="none"
                        d="M0 33.9711C8.92338 33.4535 16 26.0531 16 17V34H0V33.9711Z"
                    />
                    <path
                        stroke="none"
                        d="M0 0.0289236V0H16V17C16 7.94685 8.92338 0.546541 0 0.0289236Z"
                    />
                </svg>
            </div>
            <div class="bg-dark-blue h-full rounded-br-xl" />
        </div>

        <!--<div v-if="url" class="absolute -bottom-6 -translate-x-1/2 left-1/2 bg-light-red rounded-lg overflow-hidden can-hover:hover:shadow-xl px-3 py-2">
            <span class="">Profitez-en&thinsp;!</span>
        </div>-->
    </a>
</template>
